<template>
    <div>
        <v-tooltip  top :attach="`#file-${file.id}`">
            <template v-slot:activator="{ on, attrs }">
                <v-row no-gutters  v-bind="attrs" v-on="on" >
                    <div style="position:relative" :id="'file-' + file.id">
                        <span style="font-size:36px;" 
                        :class="`fiv-viv fiv-icon-${$fileExtension(file.fileName)}`"></span>
                    </div>
                
                    
                    <v-col class="ml-1" style="line-height: normal;">
                        <div>
                            <span class="text-overflow "  style="width: 130px;font-weight: 500;"> {{ file.fileName }}</span>
                        </div>
                        <div class="text-muted" style="font-size: smaller;">
                            {{ $formatFileSize(file.size, 2) }}
                        </div>
                    </v-col>
                </v-row>

            
            </template>
            <span>{{ file.fileName }}</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    props: ['file']
}
</script>

<style>


</style>